'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./~/dunder-proto/~/gopd/gOPD.js
// module id = 404
// module chunks = 0